import { useRef, useState } from "react";
import { IconButton } from "@mui/material";

import useClickOutside from "../../../hooks/useClickOutside";
import { Logo } from "../Logo/Logo";
import classes from "./MobileHeader.module.scss";
import { additionalMenuItems } from "../MenuItems/MenuItems";
import { IListing, IMobileHeader } from "../../interfaces";
import { MenuList } from "../MenuItems/MenuList";
import { MenuIcon } from "../../../assets/icons/MenuIcon";
import { ListingSelector } from "./components/ListingSelector";
import { Typography } from "@/shared/ui/typography";
import { useDispatch } from "react-redux";
import { SET_SELECTED_LISTINGS } from "../../../redux/actions";
import { PERFORMANCE_PAGE_ACTIONS_TO_DISPATCH } from "@/utils/constants/performancePageActions";

export const MobileHeader = ({
  activePath,
  listing,
  logo,
  navigate,
  userName,
  listings,
}: IMobileHeader) => {
  const dispatch = useDispatch();
  const [openMenu, setOpenMenu] = useState(false);

  const menuRef = useRef<any>(null);

  useClickOutside(menuRef, openMenu, () => setOpenMenu(false));

  const noListings = !listings || listings.length === 0;

  const onSelect = (listings: IListing[]) => {
    setOpenMenu(false);
    const listingIDs = listings?.map((listing) => listing.property_id);

    dispatch({
      type: SET_SELECTED_LISTINGS,
      payload: { listings },
    });
    PERFORMANCE_PAGE_ACTIONS_TO_DISPATCH.forEach((action) => {
      dispatch({
        type: action,
        payload: listingIDs,
      });
    });
  };

  return (
    <>
      <div className={classes.mobileHeaderWrapper}>
        <div className={classes.mobileHeaderContainer} ref={menuRef}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpenMenu(!openMenu)}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
          <Logo className={classes.logo} mobile src={logo} />
        </div>
        {noListings ? (
          <div className={classes.noListings}>
            <Typography variant="text-md" weight="medium">
              No listings available
            </Typography>
          </div>
        ) : (
          <>
            <ListingSelector onSelect={onSelect} listings={listings} />
          </>
        )}
      </div>
      <div className={openMenu ? classes.mobileMenuContainer : classes.hidden}>
        <div className={classes.userData}>
          <p className={classes.userName}>{userName}</p>
          <p className={classes.userListing}>{listing}</p>
        </div>
        <MenuList
          activePath={activePath}
          list={additionalMenuItems}
          navigate={navigate}
        />
      </div>
    </>
  );
};
